import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ControlTowerLayer from "../components/ControlTowerLayer";

const ControlTowerPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Control Tower" />
        <ControlTowerLayer />
      </MasterLayout>
    </>
  );
};

export default ControlTowerPage;
